var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2C2D2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9505 11.9998L15.8026 9.14765C16.0652 8.88511 16.0652 8.45945 15.8026 8.19694C15.5401 7.9344 15.1144 7.9344 14.8519 8.19694L11.9997 11.0491L9.14759 8.19691C8.88504 7.93436 8.45942 7.93436 8.19688 8.19691C7.93437 8.45945 7.93437 8.88511 8.19688 9.14761L11.049 11.9997L8.19688 14.8519C7.93437 15.1144 7.93437 15.5401 8.19688 15.8026C8.45942 16.0651 8.88504 16.0651 9.14759 15.8026L11.9997 12.9504L14.8519 15.8026C15.1144 16.0651 15.5401 16.0651 15.8026 15.8026C16.0652 15.5401 16.0652 15.1144 15.8026 14.8519L12.9505 11.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.b8720c7dd214342c5e972cc676cbd59c.svg";
export { ForwardRef as ReactComponent };